var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-block__group"},[(_vm.showLabel)?_c('label',{staticClass:"filter-block__text",attrs:{"for":_vm.field.attribute}},[_vm._v("\n    "+_vm._s(_vm.fieldLabel || _vm.field.label)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("field")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }